// Function to determine environment and set configuration
const getConfig = () => {
  // Determine the hostname (used for environment-specific logic)
  const hostname =
    typeof window !== "undefined" ? window.location.hostname : ""; // Ensure it works in Node.js

  // const isLocal = false;

  // Environment-specific base URL and API key logic
  if (hostname === "localhost" || hostname.startsWith("192.168.")) {
    // Development (localhost or local network)
    return {
      // baseUrl: "https://mcl.watsoo.com/watsoo-vts/",
      // baseUrl: "http://10.201.0.36:8082/",
      // baseUrl: "http://192.168.200.26:8085/watsoo-vts/",

      // baseUrl: "http://192.168.30.35:6789/be-watsoo_vts_mcl_test/",
      // baseUrl: "http://192.168.30.35:6789/be-watsoo_vts_mcl_test/",
      // baseUrl: "http://staging.watsoo.com:8085/mcl-vts-staging-test-Mar02/",

      // baseUrl: "http://192.168.40.242:8082/",

      // baseUrl: "http://192.168.30.35:6789/mcl-vts-staging-test/",
      // baseUrl: "https://stagingmcl.watsoo.com/backend/",
      // baseUrl: "http://192.168.200.26:8085/watsoo-vts/",
      // baseUrl: "http://192.168.40.242:8082/",
      baseUrl: "https://www.mclvts.in/watsoo-vts/",
      // apiKey: "AIzaSyDL9J82iDhcUWdQiuIvBYa0t5asrtz3Swk",
      // webSocketUrl: "https://mcl.watsoo.com/watsoo-vts/ws",
      // baseUrlGps: "https://mcl.watsoo.com/watsoo-traccar/",
      // showConsole: false,
      // rawDataBaseUrl: "https://mcl.watsoo.com/",
      // baseUrl: "https://www.mclvts.in/watsoo-vts/",
      // baseUrl: "http://192.168.200.26:8085/watsoo-vts/",
      //(manisha's ip)
      // baseUrl: "http://192.168.12.69:8082/",

      //  (Raukad's ip)
      // baseUrl: "http://192.168.90.51:8082/",

      apiKey: "AIzaSyDL9J82iDhcUWdQiuIvBYa0t5asrtz3Swk",
      webSocketUrl: "https://www.mclvts.in/watsoo-vts/ws",
      baseUrlGps: "https://mclcore.watsoo.com/",
      showConsole: false,
      rawDataBaseUrl: "https://www.mclvts.in/",
      baseUrlGpsOld: "https://mclcoreold.watsoo.com/",
      isLocal: true,
      encryptionEnabled: false, // ✅ local backend doesn't need encryption
    };
  } else if (hostname.includes("stagingmcl")) {
    // Staging environment
    return {
      baseUrl: "https://stagingmcl.watsoo.com/backend/",
      apiKey: "AIzaSyD5y7I25p_GnEpt_mcLV30lLJGbpmDU6Dw", // Staging API key
      webSocketUrl: "https://mcl.watsoo.com/watsoo-vts/ws",
      baseUrlGps: "https://mcl.watsoo.com/watsoo-traccar/",
      showConsole: false,
      rawDataBaseUrl: "https://mcl.watsoo.com/",
      baseUrlGpsOld: "https://mclcoreold.watsoo.com/",
      isLocal: false,
      encryptionEnabled: true, // ✅ explicit
    };
  } else if (hostname === "mcl.watsoo.com") {
    return {
      baseUrl: "https://mcl.watsoo.com/watsoo-vts/",
      apiKey: "AIzaSyD5y7I25p_GnEpt_mcLV30lLJGbpmDU6Dw",
      webSocketUrl: "https://mcl.watsoo.com/watsoo-vts/ws",
      baseUrlGps: "https://mcl.watsoo.com/watsoo-traccar/",
      showConsole: false,
      rawDataBaseUrl: "https://mcl.watsoo.com/",
      baseUrlGpsOld: "https://mclcoreold.watsoo.com/",
      isLocal: false,
      encryptionEnabled: false,
    };
  } else {
    // Production environment
    return {
      // baseUrl: "https://mcl.watsoo.com/watsoo-vts/",
      // apiKey: "AIzaSyD5y7I25p_GnEpt_mcLV30lLJGbpmDU6Dw", // Production API key
      // webSocketUrl: "https://mcl.watsoo.com/watsoo-vts/ws",
      // baseUrlGps: "https://mcl.watsoo.com/watsoo-traccar/",
      // showConsole: true,
      // rawDataBaseUrl: "https://mcl.watsoo.com/",
      // baseUrl: "http://192.168.200.26:8085/watsoo-vts/",

      baseUrl: "https://www.mclvts.in/watsoo-vts/",
      apiKey: "AIzaSyD5y7I25p_GnEpt_mcLV30lLJGbpmDU6Dw",
      webSocketUrl: "https://www.mclvts.in/watsoo-vts/ws",
      baseUrlGps: "https://mclcore.watsoo.com/",
      showConsole: true,
      rawDataBaseUrl: "https://www.mclvts.in/",
      baseUrlGpsOld: "https://mclcoreold.watsoo.com/",
      isLocal: false,
      encryptionEnabled: true, // ✅ explicit
    };
  }
};
// Get dynamic configuration
const {
  baseUrl,
  apiKey,
  showConsole,
  webSocketUrl,
  baseUrlGps,
  rawDataBaseUrl,
  baseUrlGpsOld,
  isLocal,
  encryptionEnabled, // ✅ export it
} = getConfig();
module.exports = {
  /* ================================================================================================== */
  baseUrl,
  baseUrlGps,
  baseUrlGpsOld,
  webSocketUrl,
  Username: "admin",
  Password: "admin",
  apiKey,
  AesKey: "77217A25432A462D4A614E635266556A",
  NkcWeb: false,
  VTSWeb: true,
  BJBWeb: false,
  showConsole,
  version: 0.01,
  rawDataBaseUrl,
  isLocal,
  encryptionEnabled, // ✅ expose it

  // Api endpoint name
  apiName: {
    logOut: "v1/logout",
    fileUpload: "https://storage.nyggs.com/setmedia/api/v2/save/file",
    // fileUpload: "https://storage.nyggs.com/setmedia/api/save/file",
    // fileUpload: "http://192.168.60.225:8080/api/v2/save/file",
    // fileUpload: "http://192.168.60.225:8080/api/save/file",
    // fileUpload2: "v2/uploadMultipleFiles",
    fileUpload2: "https://storage.nyggs.com/setmedia/api/save/file",
    UploadFileOnAWs: "uploadFile",
    loginApi: "v1/login",
    UserList: "api/v1/user/all",
    AddUser: "api/v1/user/add",
    ActiveUser: "api/v1/user/active/inactive",
    UpdateUser: "api/v1/user/update",
    GetUserById: "api/v1/user",
    DesignationList: "v1/designation",
    permission_category: "v1/permission_category",
    RoleList: "v1/role/all",
    SiteList: "api/v1/site/all",
    AddSiteAccess: "api/v1/add/user/site/role",
    RemoveSiteAccess: "api/v1/remove/user/site/role",
    AddRole: "v1/role/add",
    VehicleList: "api/v2/vehicle/all",
    VehicleTypeList: "api/v1/all/vehicle/actual/type",
    fetchTerminalSiteTypeList: "api/terminal/sub/types/active",
    ActiveVehicle: "api/v1/vehicle/active/inactive",
    AddVehicle: "api/v1/vehicle/add",
    VehicleById: "api/v1/vehicle/view",
    UpdateVehicle: "api/v1/vehicle/update",
    VendorList: "api/v1/vendor/all",
    AddVendor: "api/v1/vendor/add",
    UpdateVendor: "api/v1/vendor/update",
    VendorById: "api/v1/vendor/view",
    ActiveVendor: "api/v1/vendor/active/inactive",
    DriverList: "api/v1/driver/all",
    DocumentList: "api/v1/documents/all",
    RouteList: "api/v1/route/all",
    AddRoute: "api/v1/route/add",
    ActiveRoute: "api/v1/route/active/inactive",
    RouteById: "api/v1/route/id",
    UpdateRoute: "api/v1/route/update",
    SyncVehicle: "api/v1/sync/vehicle",
    DeleteFile: "deleteFiles",
    EtpOrder: "api/v1/etp/orders/view",
    TotalVendorDashboard: "api/v1/dashbord/status",
    fetchAddress: "address/v1/fetch_address",
    totalInstallGps: "api/v1/dashbord/vehicle/status",
    removeGeoFench: "api/v2/delete/geofence",
    CreateTrip: "api/v1/etp/orders/create",
    TripList: "api/v1/etp/orders/get/all/bulk",
    MaterialType: "api/v1/all/material-type",
    DestinationTripSite: "api/v1/get_destinations_from_source",
    ViewTrip: "api/v1/etp/orders/view",
    NotificationAlert: "api/v1/alert/get_all",
    KmlFileUploding: "api/uploadKmlData",
    getFuelDashboard: "getFuelDashboard",
    routeSiteSubSite: "api/v1/site/route/sub_site/all",
    removeGpsFromVehicle: "api/v1/remove/vehicle",
    routeDetele: "api/v1/route/delete",
    auditLog: "api/v1/auditLog",
    AllpermissionName: "api/v1/permission",
    ActiveRoutes: "api/v1/get/active/routes",
    UptimeReport: "api/v1/vehicle/active/inactive/history",
    maintenanceVehicleList: "api/v1/vehicle/maintenance/category",
    maintenanceAdd: "api/v1/vehicle/maintenance/add",
    upTimeMonthly: "api/v2/vehicle/uptime/report",
    updateKmlDataRoute: "api/updateKmlData",
    notificationForParent: "api/v1/outAlert/get_all",
    notificationForParentGrupe: "api/v1/alert/get_all",
    // GpsReportS End Point
    gpsReports: "api/reports",
    getDashboardData: "api/v1/mcl-dashboard",
    //vehicleCurrentStatus
    vehicleCurrentStatus: "api/v1/vehicle/current/status",
    siteCategoryType: "api/v1/site/category/all/enums",
    getAllMenus: "api/v1/get-all-menus",
    getAllApiType: "api/get/all/api-type",
    addApiPermision: "api/v1/add/permission",
    addNewRole: "v1/add/role-menu",
    getAllRolePermission: "api/get/role/permission/dashboard-data",
    updateRole: "v1/update/role-menu",
    getUiPermission: "api/get/all/ui-permissions",
    getApiPermission: "api/get/all/menu-wise/apis",
    saveDesignation: "v1/designation/add",
    dataLoss: "api/v1/data_loss_transaction",
    updateApiPermision: "api/v1/update/permission",
    deleteApiPermision: "api/v1/delete/permission",
    VehicleList2: "api/v1/transpoter/vehicle/all",

    addVehicleRemark: "api/remarks/add/v1",
    vehicleEvents: "api/v1/vehicle-events",
    getAllRemark: "api/remarks/all",
    addTransaction: "api/v1/add-vendor-tenure",
    AddNotification: "api/v2/create/notification/configuration",
    EditNotification: "api/v2/edit/notification/configuration",
    GetDetailList: "api/v1/get/notification/configuration",
    NotificationType: "api/v1/get/notification/type",
    GetNotificationList: "api/v2/get/all/notification/configuration",
    changePassword: "v2/change/password",
    forgotPassword: "v1/forgot-password",
    verifyOtp: "v1/verify-otp",
    resetPassword: "v1/reset-password",

    MineList: "api/v1/get-all-mines",

    userList: "api/v1/user/all/notification",
    fetchVehicleTransactions: "api/v1/vehicle-update-transactions",
    alertList: "",
    addAlertRemark: "api/v1/alert-remarks/add",
    alertRemarkById: "api/v1/alert-remarks/get",
    checkgpsRefId: "api/v1/get/gps/ref/id",
    gpsTrailList: "api/vehicle/gps/trail",
    getAlertGeofance: "api/v1/alert/get/all/response",
    TripListGroupByTransporter:
      "api/v2/etp/orders/get/all/grouping/vendor/bulk",
    fetchImeiList: "mcl-core-utility/api/all/imei",
    fetchRawData: "mcl-core-utility/api/device/data",
    fetchMenuMasterConfiguration: "api/v1/get-all-menus",
    fetchPowerCutAlertConfiguration: "api/get/config/power/cut/alert",
    updateMenuMasterConfiguration: "api/v1/add/menus",
    updatePowerCutAlertConfiguration: "api/update/confi/power/cut/alert",
    addSubMenus: "api/v1/add/sub/menus",
    fetchGeofenceAlertConfiguration: "api/v1/all/geofence/alert/config",
    updateGeofenceAlertConfiguration: "api/update/geofence/alert/enable",
    fetchAllArea: "api/all/area",
    fetchVehicleByMine: "api/v1/get/all/vehicle/numbers",
    nitList: "api/nit/all",
    fetchNitListForDropdown: "api/v1/nit/numbers",
    nitCreate: "api/nit/create",
    fetchDepartmentList: "api/department/type/all",
    fetchTripPerformanceList: "api/get/trip-performance-data",
    reasonTypeList: "api/reasons/usage",
    addLandmark: "api/landmark/v1/add",
    fetchLandmarkList: "api/landmark/v1/all",
    getLandmarkById: "api/landmark/v1/view",
    updateLandmark: "api/landmark/v1/update",
    nitUpdate: "api/nit/update",
    importLandmarks: "api/upload-landmarks",
    getNitById: "api/nit/id",
    getNitById2: "api/view/nit",
    pendingAlertList: "api/v1/pending-alert",
    alertApprove: "api/v1/alert-approve-reject",
    landmarkByMines: "api/landmark/v1/view/by/mines",
    importNITs: "api/upload/nit",
    deleteNit: "api/delete/nit",
    fetchNitReportList: "api/v2/etp/orders/get/all/by/nit",
    fetchNitListByVendorMine: "api/nits/by/mine/vendor",
    fetchVehicleStuckAlerts: "api/v2/vehicle/stuck",
    fetchNitLeadReport: "api/v1/nit/lead/report",

    vehicleSubTypeList: "api/v1/all/vehicle-type",
    getSiteDistance: "api/v1/site-distance/getAll",
    createSiteDistance: "api/v1/site-distance/add",
    updateSiteDistance: "api/v1/site-distance/update",
    deleteSiteDistance: "api/v1/deleteSiteDistance",
    getSiteDistanceById: "api/v1/site-distance",
    getSiteHistoryById: "api/v1/site/history",
    fetchSchedulerStatus: "api/scheduler/status",
    fetchSchedulerStopStatus: "api/scheduler/stop/status",
    startScheduler: "api/scheduler/start",
    standbyScheduler: "api/scheduler/standby",
    stopScheduler: "api/scheduler/all/stop",

    vehicleConfigTrailSearch: "api/vehicle-config/trail/search",
    vehicleConfigOperationTypes: "api/vehicle-config/operation-types",
    vehicleConfigOperation: "api/vehicle-config/operation",
    VehicleDropdown: "api/v1/vehicle/all/dropdown",
    vehicleConfigBulkOperation: "api/vehicle-config/bulk/operation",

    // Vehicle Status Report
    geofenceTracking: "api/v1/vehicles/geofence-tracking",
    vehiclePositions: "api/positions/",
  },
};
